var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh2 = function SvgRefresh2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.336 11.999v-8a.667.667 0 0 1 1.334 0v8a.667.667 0 0 1-1.334 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.475 2.53 3 3-.944.943-2.528-2.529-2.528 2.529-.944-.944 3-3 .472-.47zM10.336 10.999v-7a.667.667 0 0 1 1.334 0v7a.667.667 0 0 1-1.334 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.475 9.97-3 3-.472.471-.472-.47-3-3 .944-.944 2.528 2.529 2.528-2.529z"
  })));
};
export default SvgRefresh2;